// extracted by mini-css-extract-plugin
module.exports = {"space40":"space40-21mlWjfh","space10":"space10-2SprXtOF"};